import { AddressElement as StripeAddress } from '@stripe/react-stripe-js'

import type { AddressElementProps as StripeAddressProps } from '@stripe/react-stripe-js'

export interface AddressElementProps
  extends Omit<StripeAddressProps, 'options'> {
  options?: Partial<StripeAddressProps['options']>
}

export const AddressElement = ({ options, ...props }: AddressElementProps) => (
  <StripeAddress
    options={{
      autocomplete: {
        mode: 'disabled',
      },
      display: {
        name: 'full',
      },
      mode: 'billing',
      ...options,
    }}
    {...props}
  />
)
